import ct from "class-types.macro";
import React from "react";
import StandardPrice from "../Price";
import { VariantProps } from ".";
import LoginLink from "./LoginLink";

const O = ({ selectedProduct, user }: VariantProps) => {
  const {
    unitOfMeasure,
    price,
    showBelowMinimumAdvertisedPriceForLoggedInCustomers,
  } = selectedProduct;

  return (
    <div className="map map-override mapO">
      {user.registered && (
        <StandardPrice
          price={
            user.registered
              ? price.minimumAdvertisedPriceProperties.price
              : price.price
          }
          unitOfMeasure={unitOfMeasure}
          textSize="custom"
          className={ct("text-lg", "pt-0", "xxs:text-2xl")}
        />
      )}
      <p className="price enter-email">
        {!user.registered &&
        showBelowMinimumAdvertisedPriceForLoggedInCustomers ? (
          <>
            {"Contact us or "}
            <LoginLink>login</LoginLink>
            {" for details"}
          </>
        ) : (
          "Contact us for details"
        )}
      </p>
      <p className="to-see-price noborder">Call 717-392-7472</p>
    </div>
  );
};

export default O;
